<p-modal
  *ngIf="showDPO"
  modalId="modalId"
  title="Politique de gestion des données"
  [canClose]="true"
  (cancel)="closeModal()"
>
  <iframe
    [src]="pdfUrl | safe"
    title="Politique de gestion des données"
    width="100%"
    height="600px"
    frameborder="0"
  >
  </iframe>
</p-modal>
